import { CompanySearchResult } from "@/entities/Company/Company.types";
import clsx from "clsx";

export const CompanyItem = ({
    company,
    onClick,
    active,
}: {
    company: CompanySearchResult;
    onClick: () => void;
    active?: boolean;
}) => {
    return (
        <div
            className={clsx(
                "w-full cursor-pointer select-none rounded-md p-4",
                "body-s text-left",
                active
                    ? "text-default bg-slate-700"
                    : "subdued hover:bg-slate-700 hover:text-slate-200",

                "transition-colors duration-150 ease-in-out",
            )}
            onClick={onClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onClick();
                }
            }}
        >
            {company.name}
        </div>
    );
};
